import { saveAs } from 'file-saver';
import * as React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import Error from './Error';
import Form from './Form';
import { decryptMessage } from './utils';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';

const Download = () => {
  const [loading, setLoading] = useState(false);
  const [error, showError] = useState(false);
  const { key, password } = useParams();
  const { t } = useTranslation();

  const decrypt = useCallback(async () => {
    if (!password) {
      return;
    }
    setLoading(true);
    const url = process.env.REACT_APP_BACKEND_URL
      ? `${process.env.REACT_APP_BACKEND_URL}/file`
      : '/file';
    try {
      const request = await fetch(`${url}/${key}`);
      if (request.status === 200) {
        const data = await request.json();
        const file = await decryptMessage(data.message, password, 'binary');
        saveAs(
          new Blob([file.data as string], {
            type: 'application/octet-stream',
          }),
          file.filename,
        );
        setLoading(false);
        return;
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
    showError(true);
  }, [password, key]);

  useEffect(() => {
    decrypt();
  }, [decrypt]);

  return (
    <div>
      {loading && (
        <h3>
          {t("Fetching from database and decrypting in browser, please hold...")}
        </h3>
      )}
      {!loading && password && !error && <DownloadSuccess />}
      <Error display={error} />
      <Form display={!password} uuid={key} prefix="f" />
    </div>
  );
};

const DownloadSuccess = () => {
  const [redirect, setRedirect] = useState(false);
  const { t } = useTranslation();

  if (redirect) {
    return <Redirect to={'/upload'}/>
  }

  return (
    <div>
      <h3 className={'c-gray fs-32'}>{t("Downloading file and decrypting in browser, please hold...")}</h3>
      <p className={'c-light-gray fs-16'}>{t("Make sure to download the file since it is only available once")}</p>
      <div className={'text-right'} style={{marginTop: '34px'}}>
        <Button
          color="secondary"
          size="lg"
          className="fs-14 text-uppercase no-focus-shadow btn-gray-2 no-border-r encrypt-message"
          style={{padding: '15px 32px'}}
          onClick={() => setRedirect(true)}
        >
          <span>{t('Upload new file')}</span>
        </Button>
      </div>
    </div>
  );
};
export default Download;
